import Card from "./Card";

export default function StatCard({ label, value }: { label: string; value: string }) {
    return (
        <Card>
            <p className="text-sm text-gray-500">{label}</p>
            <p className="mt-2 text-2xl font-bold text-gray-900">{value}</p>
        </Card>
    );
}